import { Drawer } from 'vaul'

import { BottomSheetContent } from './components/bottom-sheet-content'
import { BottomSheetHeader } from './components/bottom-sheet-header'

type BottomSheetProps = React.ComponentPropsWithRef<typeof Drawer.Root>

// Root
function BottomSheetRoot(
  props: React.ComponentPropsWithRef<typeof Drawer.Root>
) {
  return <Drawer.Root {...props} data-scope="bottom-sheet" />
}

// Trigger
function BottomSheetTrigger(
  props: React.ComponentPropsWithRef<typeof Drawer.Trigger>
) {
  return <Drawer.Trigger {...props} data-scope="bottom-sheet-trigger" />
}

// Close
function BottomSheetClose(
  props: React.ComponentPropsWithRef<typeof Drawer.Close>
) {
  return <Drawer.Close {...props} data-scope="bottom-sheet-close" />
}

// Composition
const BottomSheet = {
  Root: BottomSheetRoot,
  Trigger: BottomSheetTrigger,
  Content: BottomSheetContent,
  Header: BottomSheetHeader,
  Close: BottomSheetClose,
}

export { BottomSheet }
export type { BottomSheetProps }
